import React from 'react';
import { BuildingIcon, SearchIcon, UsersIcon, CpuIcon, CheckCircleIcon } from 'lucide-react';
export function ScraperPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-2203">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2204">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2205">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2206">
            Pricing for every{' '}
            <span className="text-blue-600" data-id="element-2207">Google Maps data</span> workflow
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2208">
            Pay only for the local business data you extract. Every account
            starts with free credits to test our Google Maps scraper.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-2209">
          {/* Search Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2210">
            <div className="flex items-center gap-3 mb-4" data-id="element-2211">
              <SearchIcon className="w-5 h-5 text-slate-400" data-id="element-2212" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2213">
                Search Google Maps data
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2214">
              Find businesses by location, category, and rating from Google Maps
              data
            </p>
            <div data-id="element-2215">
              <div className="flex items-baseline gap-2" data-id="element-2216">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2217">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2218">unlimited searches</p>
            </div>
          </div>

          {/* Find People Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2219">
            <div className="flex items-center gap-3 mb-4" data-id="element-2220">
              <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-2221" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2222">
                Find decision makers
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2223">
              Get verified owner contacts for businesses scraped from Google
              Maps
            </p>
            <div className="space-y-4" data-id="element-2224">
              <div data-id="element-2225">
                <div className="flex items-baseline gap-2" data-id="element-2226">
                  <span className="text-4xl font-bold text-slate-900" data-id="element-2227">
                    from $3
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1" data-id="element-2228">
                  per 100 contacts found
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3 pt-4 border-t border-slate-100" data-id="element-2229">
                <div data-id="element-2230">
                  <div className="text-lg font-bold text-slate-900" data-id="element-2231">$3</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2232">per 100 names</p>
                </div>
                <div data-id="element-2233">
                  <div className="text-lg font-bold text-slate-900" data-id="element-2234">$6</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2235">per 100 emails</p>
                </div>
                <div data-id="element-2236">
                  <div className="text-lg font-bold text-slate-900" data-id="element-2237">$24</div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2238">per 100 phones</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tech Stack Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2239">
            <div className="flex items-center gap-3 mb-4" data-id="element-2240">
              <CpuIcon className="w-5 h-5 text-slate-400" data-id="element-2241" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2242">
                Detect tech stack
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2243">
              Identify what tools Google Maps businesses use to personalize your
              outreach
            </p>
            <div data-id="element-2244">
              <div className="flex items-baseline gap-2" data-id="element-2245">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2246">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2247">
                per 100 records enriched
              </p>
            </div>
          </div>

          {/* Export Leads Card */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-2248">
            <div className="flex items-center gap-3 mb-4" data-id="element-2249">
              <BuildingIcon className="w-5 h-5 text-slate-400" data-id="element-2250" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-2251">Export leads</h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-2252">
              Export enriched leads with employee count, hiring signals, and
              more
            </p>
            <div data-id="element-2253">
              <div className="flex items-baseline gap-2" data-id="element-2254">
                <span className="text-4xl font-bold text-slate-900" data-id="element-2255">$0.15</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2256">
                per 100 records exported
              </p>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-2257">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2258">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2259" />
            <span data-id="element-2260">Pay only for results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2261">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2262" />
            <span data-id="element-2263">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-2264">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-2265" />
            <span data-id="element-2266">No credit card required</span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-2267">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-2268">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-2269">
              Try for free
            </a>
          </div>
          <p className="text-sm text-slate-500 font-medium" data-id="element-2270">
            No credit card required
          </p>
        </div>
      </div>
    </section>;
}